import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["navigateToImpl", "externalLink", "callback", "href", "currentHostUrl", "navigateTo", "preventDefault", "disableAjaxLinks"];
import React from "react";
import { string, func, bool } from "prop-types";

var preventDefaultImpl = function preventDefaultImpl(e) {
  e.preventDefault();
  e.stopPropagation();
};
/**
 * This component generates an anchor tag. Instead of doing a browser page load, it will go to the next page via AJAX. Analytics scripts will be fired correctly (and if not, it's a bug)
 * LinkBase is not connected to the store or plugged to context, this is used as an alternative for usecases such as partial hydration where context is lost.
 *
 * ```javascript
 * import { LinkBase } from '@quintype/components';
 * <LinkBase href="/section/story-slug" otherLinkAttribute="value">Text here</LinkBase>
 * ```
 * @category Other
 * @component
 */


export var LinkBase = function LinkBase(_ref) {
  var navigateToImpl = _ref.navigateToImpl,
      externalLink = _ref.externalLink,
      callback = _ref.callback,
      href = _ref.href,
      currentHostUrl = _ref.currentHostUrl,
      navigateTo = _ref.navigateTo,
      _ref$preventDefault = _ref.preventDefault,
      preventDefault = _ref$preventDefault === void 0 ? preventDefaultImpl : _ref$preventDefault,
      _ref$disableAjaxLinks = _ref.disableAjaxLinks,
      disableAjaxLinks = _ref$disableAjaxLinks === void 0 ? global.disableAjaxLinks || global.disableAjaxNavigation : _ref$disableAjaxLinks,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  navigateTo = navigateTo || navigateToImpl;
  return /*#__PURE__*/React.createElement("a", Object.assign(otherProps, {
    href: href,
    onClick: function onClick(e) {
      if (disableAjaxLinks || e.ctrlKey || e.metaKey || e.shiftKey) {
        return;
      }

      var relativeLink = href.startsWith(currentHostUrl) ? href.replace(currentHostUrl, "") : href;

      if (!relativeLink.startsWith("/")) {
        return;
      }

      preventDefault(e);

      if (externalLink) {
        global.open(externalLink, "_blank");
      } else {
        navigateTo(relativeLink);
      }

      typeof callback === "function" && callback(e);
    }
  }));
};